import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OfrepFlagsMap } from "@src/cloud-connect/feature-toggles/entities/ofrep-flags-map";

interface FeatureFlagsState {
  flags: OfrepFlagsMap;
  loaded: boolean;
}

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState: { flags: {}, loaded: false } as FeatureFlagsState,
  reducers: {
    /**
     * Full replace — used once on login.
     */
    setFeatureFlags(state, action: PayloadAction<OfrepFlagsMap>) {
      state.flags = action.payload;
      state.loaded = true;
    },

    clearFeatureFlags(state) {
      state.flags = {};
      state.loaded = false;
    },
  },
});

export const { setFeatureFlags, clearFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
